import { USER_PROP } from './constants'

export const checkEmailValid = (val) => {
    const reg = new RegExp(
        "^\\w+([-+.']\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*$",
    )
    return reg.test(val)
}
export const checkMultiEmailValid = (val) => {
    const result = val.split(',')
    for (let i = 0; i < result.length; i++) {
        if (!checkEmailValid(result[i])) {
            return false
        }
    }
    return true
}
/*  Minimum eight and maximum 20 characters,
    at least one uppercase letter,
    one lowercase letter,
    one number and one special character */
export const checkPasswordStrength = (val) => {
    const reg = new RegExp(
        '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[@$!%*?#^&])[A-Za-z\\d@$!%*?#^&]{8,20}$',
    )
    return reg.test(val)
}
export const checkFieldValid = (field, value) => {
    switch (field) {
        case USER_PROP.FNAME:
        case USER_PROP.LNAME:
        case USER_PROP.COUNTRY:
        case USER_PROP.ROLE:
        case USER_PROP.TITLE:
        case USER_PROP.AFFILIATION:
            return !!value
        case USER_PROP.EMAIL:
            return checkEmailValid(value)
        case USER_PROP.PASSWORD:
            return checkPasswordStrength(value)
        default:
            return false
    }
}
